// Copyright (c) Meta Platforms, Inc. and affiliates.

/**
 * @file renderDropdownItems.tsx
 * @output Converts data-driven menu items into DropdownMenuItem components
 * @position Utility; used by DropdownMenu to unify data-driven and compound paths
 */

import * as stylex from '@stylexjs/stylex';
import { Divider } from "../Divider/index.js";
import { DropdownMenuItem } from "./DropdownMenuItem.js";
import "../theme/tokens.stylex.js";
import { spacingVars, typographyVars, typeScaleVars, colorVars } from "../theme/tokens.stylex.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
  divider: {
    kqGvvJ: "xsq74q5",
    $$css: true
  }
};
function getItemKey(item) {
  return `item-${item.label}`;
}
function getSectionKey(section, index) {
  return `section-${section.title ?? index}`;
}

/**
 * Converts data-driven items into DropdownMenuItem components,
 * so both modes share the same rendering and keyboard navigation path.
 */
export function renderDropdownItems(items) {
  const elements = [];
  for (let i = 0; i < items.length; i++) {
    const option = items[i];
    if ('type' in option && option.type === 'divider') {
      elements.push(/*#__PURE__*/_jsx(Divider, {
        xstyle: styles.divider
      }, `divider-${i}`));
    } else if ('type' in option && option.type === 'section') {
      elements.push(/*#__PURE__*/_jsxs("div", {
        role: "group",
        "aria-label": option.title,
        children: [option.title && /*#__PURE__*/_jsx("div", {
          ...{
            className: "xu0wf1k xf314gf x9ynric x141an7d x1ltkj2j xv1l7n4 x87ps6o"
          },
          "aria-hidden": "true",
          children: option.title
        }), option.items.map(item => /*#__PURE__*/_jsx(DropdownMenuItem, {
          icon: item.icon,
          label: item.label,
          onClick: item.onClick,
          isDisabled: item.isDisabled
        }, getItemKey(item)))]
      }, getSectionKey(option, i)));
    } else if (!('type' in option)) {
      elements.push(/*#__PURE__*/_jsx(DropdownMenuItem, {
        icon: option.icon,
        label: option.label,
        onClick: option.onClick,
        isDisabled: option.isDisabled
      }, getItemKey(option)));
    }
  }
  return elements;
}